<template>
  <div
    v-if="isInterlocutorOnline"
    class="online-status"
  >
    <span class="online-status__title">
      {{ trans('offer.contact.status.online') }}
    </span>

    <span class="online-status__icon" />
  </div>
</template>

<script>
import { translationMixin } from '@tools/translation';
import { useOnlineStore } from '@stores/useOnlineStore';
import { storeToRefs } from 'pinia';

export default {
  mixins: [ translationMixin ],
  setup() {
    const interlocutor = window.initialAppState.interlocutor ?? null;
    const onlineStore = useOnlineStore();
    if (interlocutor) {
      onlineStore.subscribeUserOnline(interlocutor.id);
    }
    const { isOnlineByUser } = storeToRefs(useOnlineStore());

    return { interlocutor, isOnlineByUser };
  },
  computed: {
    isInterlocutorOnline() {
      return this.isOnlineByUser.get(this.interlocutor.id) ?? false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.online-status {
  @include fontBodySmall;
  display: flex;
  align-items: center;
  gap: toRem(4);
  color: $colorGreen;

  &__icon {
    @include sprite(ph_status);
  }
}
</style>
